import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '../../compat/muiStyles';
import mainStyle from '../../assets/mainStyle';
import { getReadingValue } from '../../utils/readings';

const useStyles = makeStyles({
  ...mainStyle,
  root: {},
});

const Settings = {
  Name: 'Value',
  Display: true,
  options: {
    view: null,
    settings: [
      {
        id: 'valueName',
        type: 'text',
        name: 'Name',
      },
      {
        id: 'value',
        type: 'text',
        name: 'Value',
      },
      {
        id: 'unit',
        type: 'text',
        name: 'Unit',
      },
    ],
    grid: true,
  },
};

const View = ({ DeviceData, Settings }) => {
  useStyles();
  const value = DeviceData && DeviceData[0] ? getReadingValue(DeviceData[0], Settings.value) : undefined;

  if (value === undefined || value === null || value === '') {
    return (
      <Box>
        {Settings.valueName ? <strong>{Settings.valueName}: </strong> : null}
        Unknown
      </Box>
    );
  }

  return (
    <Box>
      {Settings.valueName ? <strong>{Settings.valueName}: </strong> : null}
      {value} {Settings.unit || null}
    </Box>
  );
};

export default {
  Settings,
  View,
};
